// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/live-axios';
import { dispatch } from '../index';

// types
import { DefaultRootStateProps } from 'types';

// ----------------------------------------------------------------------

const initialState: DefaultRootStateProps['section'] = {
	error: null,
	sections: [],
};

const slice = createSlice({
	name: 'notificationTrigger',
	initialState,
	reducers: {
		hasError(state, action) {
			state.error = action.payload;
		},

		getSectionsSuccess(state, action) {
			state.sections = action.payload;
		},
	},
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export const sectionApi = {
	getAll: () => async () => {
		try {
			const response = await axios.get('/section');
			dispatch(slice.actions.getSectionsSuccess(response.data));
		} catch (error) {
			dispatch(slice.actions.hasError(error));
		}
	},
};
